import { DeleteOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import { mainActions } from "../../../../store/main/mainSlice";
import { useSelector, useDispatch } from "react-redux";

// type PropsType = {
//   items: ItemsTableInterface[];
// };
const VoidOrder = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [t] = useTranslation("common");
  const dispatch = useDispatch();
  const items = useSelector((state: any) => state.main.items);

  const config = {
    content: <>Do you want to delete this order?</>,
    okText: `${t("confirm")}`,
    cancelText: `${t("cancel")}`,
    onOk: () => {
      dispatch(mainActions.clearInvoice());
    },
    onCancel: () => {},
  };
  return (
    <>
      <DeleteOutlined
        onClick={() => {
          items.length > 0 && modal.confirm({ ...config, centered: true });
        }}
        style={
          items.length === 0
            ? {
                fontSize: "24px",
                color: "#9e9e9e",
                cursor: "not-allowed",
              }
            : {
                fontSize: "24px",
                color: "#FF0000",
                cursor: "pointer",
              }
        }
      />
      {contextHolder}
    </>
  );
};

export default VoidOrder;
